import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { FontAwesomeIconWrapper } from '@icon/fontawesome/FontAwesomeIconWrapper';
import MediaThumb from './MediaThumb';
import { mediaValueName } from './mediaLibrary';
/**
 * @export
 * The one grid card of the media picker — used by the library, the gallery,
 * the icon grid and the icon variants grid.
 */
const MediaTile = (props) => {
    const { value, name, thumbSrc, type, selected, active, showName, onClick, onPreview, previewTitle, } = props;
    const label = name !== null && name !== void 0 ? name : mediaValueName(value);
    return _jsxs("div", { className: classNames('uxpcore_mediapicker__item', {
            'uxpcore_mediapicker__item--active': active,
            'uxpcore_mediapicker__item--selected': selected,
            'uxpcore_mediapicker__item--labelled': showName,
        }), title: label, onClick: onClick, children: [_jsx("div", { className: "uxpcore_mediapicker__item-thumb", children: _jsx(MediaThumb, { value: value, name: name, src: thumbSrc, type: type, fit: showName ? 'contain' : 'cover' }) }), showName &&
                _jsx("div", { className: "uxpcore_mediapicker__item-name", children: label }), onPreview &&
                _jsx("span", { className: "uxpcore_mediapicker__item-expand", title: previewTitle, tabIndex: 0, 
                    // The card itself is clickable — a bubbling click would toggle
                    // the selection this button exists to bypass.
                    onClick: e => { e.stopPropagation(); onPreview(); }, children: _jsx(FontAwesomeIconWrapper, { icon: ['fal', 'expand'] }) }), selected &&
                _jsx("div", { className: "uxpcore_mediapicker__item-check", children: _jsx(FontAwesomeIconWrapper, { icon: ['fas', 'check'] }) })] });
};
export default MediaTile;
